(() => {
  const initialized = new WeakSet();
  const entryStorageKey = 'vacynte:prelude-entered:v1';

  function hasRecordedEntry() {
    try {
      return window.localStorage.getItem(entryStorageKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  function recordEntry() {
    try {
      window.localStorage.setItem(entryStorageKey, 'true');
    } catch (error) {
      // The signup still works when storage is blocked by browser privacy settings.
    }
  }

  function initialize(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mark = root.querySelector('[data-vacynte-mark-stage]');
    let spinTimer;
    let resetTimer;

    if (mark && !reduceMotion) {
      const scheduleSpin = (delay) => {
        spinTimer = window.setTimeout(() => {
          mark.classList.add('is-spinning');
          resetTimer = window.setTimeout(() => {
            mark.classList.remove('is-spinning');
            scheduleSpin(9000 + Math.random() * 8000);
          }, 4400);
        }, delay);
      };

      scheduleSpin(1800 + Math.random() * 1000);

      root.addEventListener('vacynte:destroy', () => {
        window.clearTimeout(spinTimer);
        window.clearTimeout(resetTimer);
      }, { once: true });
    }

    root.querySelectorAll('[data-vacynte-video] video').forEach((video) => {
      video.muted = true;
      video.playsInline = true;

      if (reduceMotion) {
        video.pause();
      } else {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      }
    });

    const form = root.querySelector('.vacynte-access-form');
    const submit = root.querySelector('[data-vacynte-submit]');
    const submitLabel = root.querySelector('[data-vacynte-submit-label]');
    const formControls = root.querySelector('[data-vacynte-form-controls]');
    const success = root.querySelector('[data-vacynte-success]');
    const successClose = root.querySelector('[data-vacynte-success-close]');
    const already = root.querySelector('[data-vacynte-already]');

    const showAlreadyEntered = (shouldFocus = false) => {
      if (!already) return;

      if (success) success.hidden = true;
      if (formControls) formControls.hidden = true;
      already.hidden = false;
      form?.classList.add('is-already-entered');

      if (shouldFocus) {
        window.requestAnimationFrame(() => already.focus({ preventScroll: true }));
      }
    };

    if (success) {
      recordEntry();
      successClose?.addEventListener('click', () => showAlreadyEntered(true));
    } else if (hasRecordedEntry()) {
      showAlreadyEntered(false);
    }

    if (form && submit && submitLabel) {
      form.addEventListener('submit', (event) => {
        if (hasRecordedEntry()) {
          event.preventDefault();
          showAlreadyEntered(true);
          return;
        }

        if (!form.checkValidity()) return;
        submit.disabled = true;
        submit.classList.add('is-loading');
        submitLabel.textContent = 'ENTERING';
      });
    }

    if (success) {
      const settleSuccessView = () => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        window.scrollTo(0, 0);
        success.focus({ preventScroll: true });
      };

      if (window.location.hash || window.location.search.includes('customer_posted=true')) {
        const url = new URL(window.location.href);
        url.searchParams.delete('customer_posted');
        url.hash = '';
        window.history.replaceState(
          window.history.state,
          '',
          `${url.pathname}${url.search}`
        );
      }

      settleSuccessView();
      window.requestAnimationFrame(() => {
        settleSuccessView();
        window.requestAnimationFrame(settleSuccessView);
      });
      window.setTimeout(settleSuccessView, 300);
    }
  }

  function initializeAll(scope = document) {
    scope.querySelectorAll('[data-vacynte-waitlist]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-vacynte-waitlist]');
    if (root) root.dispatchEvent(new Event('vacynte:destroy'));
  });
})();
